// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: 'c590a3e',
    builtAt: '2026-08-17T14:34:27.874Z',
} as const;
